import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import PictureUpload from "components/CustomUpload/ImageUpload.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";
import NotifList from "granular/Notification/notifList.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Select from "@material-ui/core/Select";
import {
  fetchUploadAll,
  deleteLayer,
  pushLayer,
  proccessUpload,
  updateLayer
} from "../../api/layer";
import DatePicker from "react-datepicker";

import { fetchLayers } from "../../api/portal";
import Layerdt from "../../granular/MasterData/layerdt";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import _ from "lodash";
import { pushLoader } from "../../actions/main";
import { connect } from "react-redux";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";

class Layer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datalayer: this.props.datalayer,
      openAdd: false,
      openEdit: false,
      urlfile: "-",
      description: "",
      file_upload: "",
      company_code: localStorage.getItem("company_code"),
      user_id: localStorage.getItem("id"),
      loader: null,
      title: ""
    };
  }

  UNSAFE_componentWillMount() {
    console.log(localStorage);
  }

  componentDidMount() {
    // this.getDatatable();
  }

  handleDelete = id => {
    swal({
      icon: "warning",
      title: "Delete",
      text: `Are you sure to delete data layer with id: ${id}`,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        deleteLayer(id)
          .then(response => {
            if (response != null) {
              this.getDatatable();
            }
          })
          .catch(error => {
            // console.log("tidak berhasil");
            this.props.history.push("/pages/login#logout");
          });
      }
    });
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  getDatatable = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchLayers()
      .then(response => {
        if (response != null) {
          this.setState({ datalayer: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.setState({ loader: false });
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
  };

  handleSubmit = () => {
    if (this.state.name && this.state.url && this.state.legend) {
      this.setState({ openAdd: false });
      pushLayer(this.state)
        .then(response => {
          if (response != null) {
            this.getDatatable();
          }
        })
        .catch(error => {
          this.props.history.push("/pages/login#logout");
        });
    } else {
      this.setState({ errorCheck: true });
    }
  };

  handleUpdate = id => {

    let datanya = _.find(this.props.datalayer, { id: id });
    //
    this.setState({
      openAdd: true,
      id: datanya.id,
      name: datanya.name,
      url: datanya.url,
      legend: datanya.legend,
      layer: datanya.layer,
      //updated_at: datanya.updated_at,
      status: "update",
      errorCheck: false,
      title: "Update Layer"
    });
  };

  handleAdd = () => {
    this.setState({
      openAdd: true,
      id: "",
      name: "",
      url: "",
      legend: "",
      layer: "",
      status: "add",
      errorCheck: false,
      title: "Add Layer"
    });
  };

  handleChangedateNotif = event => {
    // console.log(event);

    let dd = moment(event).toDate();
    // console.log(dd);
    //console.log(moment(event._d).format("YYYY-MM-DD kk:mm:ss"));
    this.setState({ updated_at: event });
  };

  handleFileUpload = event => {
    this.setState({ file_upload: event.target.files[0] });
    //console.log(event.target.files[0].name);

    const ext = event.target.files[0].name.split(".");

    proccessUpload(event.target.files[0], ext[1])
      .then(response => {
        this.setState({ urlfile: response.data.url });
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleChangeText = () => {};

  handleSubmitUpdate = () => {
    if (this.state.name && this.state.url && this.state.legend) {
      updateLayer(this.state)
        .then(response => {
          if (response != null) {
            this.setState({
              description: "-",
              openAdd: false
            });
            this.getDatatable();
          }
        })
        .catch(error => {
          this.props.history.push("/pages/login#logout");
        });
    } else {
      this.setState({ errorCheck: true });
    }
  };

  renderAction = () => {
    if (this.state.status == "add") {
      return (
        <Button onClick={() => this.handleSubmit()} color="success" round>
          Add
        </Button>
      );
    } else {
      return (
        <Button onClick={() => this.handleSubmitUpdate()} color="success" round>
          Update
        </Button>
      );
    }
  };

  handleError = e => {
    if (!e) return true;
    return false;
  };
  handleHelperText = (e, check) => {
    if (this.state.errorCheck) if (check(e)) return "This field is required";
  };

  renderAdd = e => {
    if (localStorage.getItem("userlevel") != 3) {
      return (
        <Button color="success" round onClick={() => this.handleAdd()}>
          Add Data
        </Button>
      );
    } else {
      return <div />;
    }
  };

  render() {
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              {this.renderAdd()}
            </CardHeader>
            <Layerdt
              datatable={this.props.datalayer}
              handleDelete={this.handleDelete}
              handleUpdate={this.handleUpdate}
            />
          </Card>
          <Dialog
            fullScreen
            open={this.state.openAdd}
            onClose={() => this.handleClose("openAdd", false)}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">{this.state.title}</DialogTitle>
            <DialogContent>
              <GridContainer>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="Name"
                    id="name"
                    helpText={this.handleHelperText(
                      this.state.name,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.name)
                        : false,
                      value: this.state.name,
                      onChange: e => {
                        this.setState({ name: e.target.value });
                      }
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="Url"
                    id="url"
                    helpText={this.handleHelperText(
                      this.state.url,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.url)
                        : false,
                      value: this.state.url,
                      onChange: e => {
                        this.setState({ url: e.target.value });
                      }
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="Legend"
                    id="legend"
                    helpText={this.handleHelperText(
                      this.state.legend,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.legend)
                        : false,
                      value: this.state.legend,
                      onChange: e => {
                        this.setState({ legend: e.target.value });
                      }
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="Layer"
                    id="layer"
                    inputProps={{
                      value: this.state.layer,
                      onChange: e => {
                        this.setState({ layer: e.target.value });
                      }
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
              </GridContainer>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.handleClose("openAdd", false)}
                color="danger"
                round
              >
                Cancel
              </Button>
              {this.renderAction()}
            </DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushLoader }
  )(Layer)
);
